<template>
	<nav class="main-navigation">
		<ul class="main-navigation__list">
			<li class="main-navigation__list-item">
				<router-link
					:to="{ name: $GLOBALS.ROUTE_HOME }"
					class="main-navigation__link"
					exact
				>
					Home
				</router-link>
			</li>
			<li class="main-navigation__list-item">
				<button
					@click="$store.commit('modalVisible', {modal: 'chooseTopic', boolean: true})"
					type="button"
					class="main-navigation__link btn--no-style"
				>
					Browse Topics
				</button>
			</li>
			<li class="main-navigation__list-item">
				<router-link
					to="/information"
					class="main-navigation__link"
					exact
				>
					Information
				</router-link>
			</li>
			<li class="main-navigation__list-item">
				<router-link
					to="/contact-us"
					class="main-navigation__link"
					exact
				>
					Contact Us
				</router-link>
			</li>
		</ul>
	</nav>
</template>

<script>
export default {};
</script>
